export default __webpack_public_path__ + "static/KeywordResearch_02_03@2x-9ac0be0732c3d7d3814935d012c53623.webp";